const X_EMBED_FEATURES = {
  tfw_timeline_list: {
    bucket: [],
    version: null,
  },
  tfw_follower_count_sunset: {
    bucket: true,
    version: null,
  },
  tfw_tweet_edit_backend: {
    bucket: 'on',
    version: null,
  },
  tfw_refsrc_session: {
    bucket: 'on',
    version: null,
  },
  tfw_fosnr_soft_interventions_enabled: {
    bucket: 'on',
    version: null,
  },
  tfw_mixed_media_15897: {
    bucket: 'treatment',
    version: null,
  },
  tfw_experiments_cookie_expiration: {
    bucket: 1209600,
    version: null,
  },
  tfw_show_birdwatch_pivots_enabled: {
    bucket: 'on',
    version: null,
  },
  tfw_duplicate_scribes_to_settings: {
    bucket: 'on',
    version: null,
  },
  tfw_use_profile_image_shape_enabled: {
    bucket: 'on',
    version: null,
  },
  tfw_video_hls_dynamic_manifests_15082: {
    bucket: 'true_bitrate',
    version: null,
  },
  tfw_legacy_timeline_sunset: {
    bucket: true,
    version: null,
  },
  tfw_tweet_edit_frontend: {
    bucket: 'on',
    version: null,
  },
}

export const xEmbedFeaturesBase64 = Buffer.from(JSON.stringify(X_EMBED_FEATURES), 'utf8').toString('base64')
